import { Box, Icon, IconColor, Tooltip, Typography } from "@outschool/backpack";
import { faArrowUpRightFromSquare, faQuestionCircle } from "@outschool/icons";
import { Trans, useTranslation } from "@outschool/localization";
import { ExternalLink } from "@outschool/ui-components-shared";
import { joinMembershipPath } from "@outschool/routes";
import React from "react";
import { SERVICE_FEE_PERCENTAGE } from "@outschool/business-rules";

export default function MarketplaceFeeInfo({
  iconColor = "primary",
}: {
  iconColor?: IconColor;
}) {
  const { t } = useTranslation(
    "ui-components-website\\IterableEmailCaptureBox",
  );

  const serviceFeePercentage = SERVICE_FEE_PERCENTAGE;
  return (
    <Tooltip
      title={
        <Box>
          <Typography variant="subtitle1">
            {t("What is the Marketplace Fee?")}
          </Typography>

          <Trans t={t}>
            <Typography variant="body2">
              The Marketplace Fee is a {{ serviceFeePercentage }}% charge
              applied to your purchase price. This fee helps us run and maintain
              the platform, such as for security and transaction processing.
              <Box sx={{ marginTop: "1em" }}>
                Did you know? Members pays no marketplace fees and receive free
                monthly credits.{" "}
                <ExternalLink
                  url={joinMembershipPath()}
                  trackingName="subscription_join_marketplace_fee_tooltip"
                >
                  {" "}
                  Learn more{" "}
                  <Icon
                    icon={faArrowUpRightFromSquare}
                    color={iconColor}
                    sx={{ marginLeft: "0.25em", cursor: "pointer" }}
                  />
                </ExternalLink>
              </Box>
            </Typography>
          </Trans>
        </Box>
      }
    >
      <Icon
        icon={faQuestionCircle}
        color={iconColor}
        sx={{ marginLeft: "0.25em", cursor: "pointer" }}
      />
    </Tooltip>
  );
}
